import React, {useContext} from "react";
import "./Footer.scss";
import Reveal from "../reveal/Reveal";
import StyleContext from "../../contexts/StyleContext";

export default function Footer() {
  const {isDark} = useContext(StyleContext);
  return (
    <Reveal direction="up">
      <div className={`footer-div${isDark ? " footer-dark" : ""}`}>
        <div className="footer-line" aria-hidden="true" />
        <p className="footer-text">
          Designed & built by{" "}
          <span className="footer-name">H. M. Umair Khalid</span>
        </p>
        <p className="footer-copy">
          © {new Date().getFullYear()} · Full-Stack Developer
        </p>
        <a href="#greeting" className="footer-top-link">
          Back to top ↑
        </a>
      </div>
    </Reveal>
  );
}
